export { useIsLoggedIn } from './lib/useIsLoggedIn';
export { useSetIsLoggedIn } from './lib/useSetIsLoggedIn';
export { useUser } from './lib/useUser';
export { useSetUser } from './lib/useSetUser';
export { getUserData } from './lib/getUserData';

export {
    Provider as UserProvider,
    setLoggedIn,
    setUser
} from './lib/userProvider';

export {
    ACTIVE_SESSION_COOKIE_NAME,
    setActiveSession,
    requestSessionType
} from './lib/setActiveSession';

export type { SessionState as UserState } from './lib/user.types';
